module.exports = new __parcel__URL__("volcano--discovery-cover.1aa79686.jpg").toString();